import { api } from "../../api/client.ts";
import { t } from "../../i18n/index.ts";
import { bump, useAction } from "../../lib/resource.ts";
import { toast } from "../../lib/toast.ts";

/**
 * Saving settings (a space's, an organization's): a PATCH to `path`, said so, and everything on screen refetched (the
 * sidebar shows names, locks and the triage area too). Returns [save, busy].
 */
export function useSaveSettings(path: string): [(body: Record<string, unknown>) => void, boolean] {
  return useAction(async (body: Record<string, unknown>) => {
    await api.patch(path, body);
    toast(t("settings.saved"));
    bump();
  });
}
